import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import CreateIcon from '@material-ui/icons/Add'
import OpenIcon from '@material-ui/icons/Check'
import EditIcon from '@material-ui/icons/Ballot'
import DeleteIcon from '@material-ui/icons/DeleteForever'
import SortIcon from '@material-ui/icons/Sort'

import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp.js';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown.js';

import PaperBlock from "../../ui/PaperBlock"

/**
 * selected
 * orderByDate
 * 
 * onCreatePurchaseClick
 * onOpenPurchase(purchase)
 * onEditPurchaseClick(purchase)
 * onDeletePurchaseClick(purchase)
 * onOrderByDateClick()
 */

class ControlPanel extends Component {

    render() {
        return <PaperBlock style = {{display: "flex"}}>

            <Tooltip title = "Создать"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreatePurchaseClick === "function") {
							this.props.onCreatePurchaseClick()
						}
					}}
				>
					<CreateIcon />
				</Button>
			</div></Tooltip>

            <Tooltip title = "Открыть"><div>
				<Button
                    disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onOpenPurchaseClick === "function") {
							this.props.onOpenPurchaseClick(this.props.selected)
						}
					}}
				>
					<OpenIcon />
				</Button>
			</div></Tooltip>


            <Tooltip title = "Редактировать"><div>
				<Button
                    disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditPurchaseClick === "function") {
							this.props.onEditPurchaseClick(this.props.selected)
						}
					}}
				>
					<EditIcon />
				</Button>
			</div></Tooltip>

            <Tooltip title = "Удалить"><div>
				<Button
                    disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeletePurchaseClick === "function") {
							this.props.onDeletePurchaseClick(this.props.selected)
						}
					}}
				>
					<DeleteIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title="Сортировать по дате"><div>
				<Button
					onClick={e=>{
						e.stopPropagation()
						if (typeof this.props.onOrderByDateClick === "function") {
							this.props.onOrderByDateClick()
						}
					}}
				>
					{(this.props.orderByDate && this.props.orderByDate === "ASC") ? <KeyboardArrowDownIcon/> : <KeyboardArrowUpIcon/>}
				</Button>
				
			</div></Tooltip>

        </PaperBlock>
    }

}

export default ControlPanel